import FeedbackSummaryTable from './summaryTable';
import FeedbackWizard from './wizard';

export default FeedbackSummaryTable;
export { FeedbackWizard };
